import { handleErrors } from './sendLeadData';
import { getTotalTimeSlots } from '@widget/utils/getTimeSlotDays';

import type { ApiResponse, AppointmentType, BookedSlotType, TimeSlotType } from './types';

export async function getTimeSlots({
  leadId,
  zipCode,
  appointmentType,
  timezone,
  prioritizeByBroker,
  brokerEmail,
}: {
  leadId?: string;
  zipCode?: string;
  appointmentType: AppointmentType;
  timezone: string;
  prioritizeByBroker?: boolean;
  brokerEmail?: string;
}) {
  const params = new URLSearchParams({
    appointmentType,
    timezone,
    ...(prioritizeByBroker ? { prioritizeByBroker: 'true' } : {}),
    ...(!leadId ? { zipcode: zipCode } : {}),
    ...(leadId && brokerEmail ? { email: brokerEmail } : {}),
  });

  const resp: Response = await fetch(
    (leadId ? `/api-widget/lead/${leadId}/timeslots?` : '/api-widget/timeslots?') + params,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  if (!resp.ok) {
    throw new Error(resp.statusText);
  }
  const responseParsed: ApiResponse<{
    timeslots: Record<string, { slots: TimeSlotType[] }>;
    bookedSlot: BookedSlotType;
  } | null> = await resp.json();
  const noSlotsData = { data: null };
  if (!responseParsed.data || responseParsed.error) {
    return noSlotsData;
  }
  const timeSlotsWithTotal = getTotalTimeSlots(responseParsed.data.timeslots);
  if (timeSlotsWithTotal.total === 0 && !responseParsed.data.bookedSlot) return noSlotsData;
  return { data: { ...timeSlotsWithTotal, bookedSlot: responseParsed.data.bookedSlot } };
}

interface BookTimeSlotType {
  email: string;
  optimal: boolean;
  startTime: string;
  type: string;
  currentUserId?: string;
  leadId: string;
  source: 'widget' | 'self-booking';
  referrer?: string;
}
export async function bookTimeSlot({ leadId, ...timeslot }: BookTimeSlotType) {
  return fetch(`/api-widget/lead/${leadId}/timeslots`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(timeslot),
  })
    .then(handleErrors)
    .then((res) => res.json());
}
